<template>
  <nav>
    <router-link class="menu-link" to="/" @click.native="$emit('clicked')">Home</router-link>
    <router-link class="menu-link" to="/prints" @click.native="$emit('clicked')">Prints</router-link>
    <router-link class="menu-link" to="/contact" @click.native="$emit('clicked')">Contact</router-link>
  </nav>

</template>

<script>
export default {
  name: "MainNavigation"
}
</script>

<style lang="scss" scoped>
.menu {
  &-link {
    color: #2d2d2d;
    font-size: 1.125rem;
    text-transform: uppercase;
    text-decoration: none;
    margin-bottom: 1.25rem;

    &:hover {
      cursor: pointer;
      color: #9e9e9e;
    }
  }

  .router-link-exact-active {
    color: #9e9e9e;
  }
}
</style>